export default "__VITE_ASSET__BCcsJ$wC__"